import React, { useState } from 'react';
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import MISReportContent from './mis_report_content';
import "../../styles.css";

const MISReport = () => {
  const [tabValue, setTabValue] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <div className="client-container">
      {isMobile ? (
        <div className="arcdx-v-pills" style={{ marginBottom: 16 }}>
          <div className={`arcdx-v-pill${tabValue === 0 ? " active" : ""}`} onClick={() => setTabValue(0)}>
            MIS Report
          </div>
          <div className={`arcdx-v-pill${tabValue === 1 ? " active" : ""}`} onClick={() => setTabValue(1)}>
            Other Breakup
          </div>
        </div>
      ) : (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        {/* Desktop: premium segmented control (same tabValue) */}
        <Box
          sx={{
            display: "inline-flex",
            gap: "4px",
            background: "#f2f4f7",
            borderRadius: "13px",
            p: "4px",
          }}
        >
          {["MIS Report", "Other Breakup"].map((label, idx) => {
            const active = tabValue === idx;
            return (
              <Box
                key={label}
                onClick={(e) => handleTabChange(e, idx)}
                sx={{
                  px: 2.25,
                  py: "8px",
                  borderRadius: "10px",
                  fontSize: "13px",
                  fontWeight: active ? 700 : 600,
                  fontFamily: "Roboto, Arial, sans-serif",
                  color: active ? "#1565C0" : "#667085",
                  background: active ? "#ffffff" : "transparent",
                  boxShadow: active ? "0 1px 3px rgba(16,24,40,0.10)" : "none",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  userSelect: "none",
                  whiteSpace: "nowrap",
                  "&:hover": { color: "#1565C0" },
                }}
              >
                {label}
              </Box>
            );
          })}
        </Box>
      </Box>
      )}

      {/* Tab Content */}
      <Box sx={{ marginTop: isMobile ? 0 : "20px" }}>
        {tabValue === 0 && <MISReportContent />}
        {tabValue === 1 && (
          <Box>
            {/* Other Breakup content will go here */}
          </Box>
        )}
      </Box>
    </div>
  );
};

export default MISReport;
